import { useState } from "react";
import { formatPhonePretty } from "../lib/format";
import { TapeCorner } from "./design";

export default function CallNumberCard({
  callNumber,
  intervieweeFirstName,
}: {
  callNumber: string;
  intervieweeFirstName?: string;
}) {
  const [copied, setCopied] = useState(false);
  const pretty = formatPhonePretty(callNumber);
  const tel = callNumber.replace(/[^\d+]/g, "");
  const name = intervieweeFirstName?.trim() || "Ihr/e Angehörige/r";

  const smsBody = encodeURIComponent(
    `Hallo ${name}, ich habe für dich ein Lebensbuch-Projekt bei Vitanara gestartet. ` +
      `Wann immer du Lust hast, ruf einfach diese Nummer an, und Konrad oder Ida hören dir zu: ${pretty}. ` +
      `Lass dir Zeit, alles bleibt vertraulich.`
  );

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(pretty);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* ignore */
    }
  };

  return (
    <div
      className="paper-deep"
      style={{
        position: "relative",
        borderRadius: 14,
        padding: "26px 22px 22px",
        boxShadow:
          "0 1px 0 rgba(0,0,0,0.18), 0 18px 36px -10px rgba(74,20,14,0.45)",
        overflow: "hidden",
      }}
    >
      <TapeCorner
        rotation={-3}
        width={72}
        height={16}
        style={{
          top: -8,
          left: 22,
          background: "rgba(168,122,58,0.55)",
        }}
      />

      <div
        className="t-caps"
        style={{
          color: "rgba(244,236,216,0.55)",
          marginBottom: 8,
        }}
      >
        Anruf-Nummer für {name}
      </div>

      <div
        style={{
          fontFamily: "var(--f-display)",
          fontWeight: 400,
          fontSize: 36,
          lineHeight: 1.05,
          letterSpacing: "0.01em",
          color: "var(--paper-50)",
          margin: "2px 0 10px",
          wordBreak: "break-word",
        }}
      >
        {pretty}
      </div>

      <p
        style={{
          fontFamily: "var(--f-body)",
          fontSize: 15.5,
          lineHeight: 1.5,
          color: "rgba(244,236,216,0.78)",
          margin: "0 0 20px",
          maxWidth: 460,
        }}
      >
        {name} ruft einfach diese Nummer an — wir erkennen automatisch, wer
        dran ist, und Konrad oder Ida legen los.
      </p>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 10,
        }}
      >
        <a
          href={`tel:${tel}`}
          style={creamPill}
        >
          Jetzt anrufen
        </a>
        <a href={`sms:?body=${smsBody}`} style={ghostCreamPill}>
          Per SMS senden
        </a>
        <a
          href={`mailto:?subject=${encodeURIComponent(
            "Deine Vitanara-Anrufnummer"
          )}&body=${smsBody}`}
          style={ghostCreamPill}
        >
          Per E-Mail senden
        </a>
        <button onClick={copy} style={ghostCreamPill}>
          {copied ? "Kopiert ✓" : "Nummer kopieren"}
        </button>
      </div>
    </div>
  );
}

const creamPill: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  background: "var(--paper-50)",
  color: "var(--oxblood-d)",
  fontFamily: "var(--f-ui)",
  fontWeight: 600,
  fontSize: 14,
  padding: "11px 18px",
  borderRadius: 999,
  border: "none",
  cursor: "pointer",
  textDecoration: "none",
  boxShadow: "0 2px 0 var(--paper-300), 0 8px 20px rgba(0,0,0,0.25)",
};

const ghostCreamPill: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  background: "transparent",
  color: "var(--paper-50)",
  fontFamily: "var(--f-ui)",
  fontWeight: 500,
  fontSize: 14,
  padding: "10px 16px",
  borderRadius: 999,
  border: "1px solid rgba(244,236,216,0.45)",
  cursor: "pointer",
  textDecoration: "none",
};
